<template>
  <div class="wrapper login" @click="divClick">
    <div class="body" v-if="showBody">
      <div class="loginbox">
        <h1 class="login-logo">
          <img
            src="@/assets/images/TDSDC/logo_login_b.png"
            width="181"
            height="43"
            alt="TATSUZIN"
          />
        </h1>
        <p class="login-searvice-name">電帳法オプション</p>
        <!--
        ****  メッセージ表示領域 ****-->
        <p class="errMsg title-ico ico-warning alignleft" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <p class="login-label alignleft ml-80px">事業者ID</p>
        <p class="login-item">
          <input
            type="text"
            class="frm-text"
            style="width: 240px"
            maxlength="50"
            ref="id"
            v-model="tatsuzinIdtemp"
            :class="{ error: isErrorAccId }"
            v-on:keydown.enter="onKeyEnter"
          />
        </p>
        <p class="errMsg alignleft ml-80px" v-show="errors_accid != ''">
          <ErrorMessageCase :errors="errors_accid"></ErrorMessageCase>
        </p>
        <p class="login-label alignleft ml-80px">パスワード</p>
        <PasswordInput
          ref="password"
          v-model="passwordtemp"
          :hasError="isErrorAccPass"
          v-on:keydown.enter="onKeyEnter"
        />
        <p class="errMsg alignleft ml-80px" v-show="errors_accpass != ''">
          <ErrorMessageCase :errors="errors_accpass"></ErrorMessageCase>
        </p>
        <p class="login-check">
          <label class="frm-checkbox">
            <input type="checkbox" v-model="LoginParam.loginInfoSaveFlag" />
            <span
              class="checkbox-item"
              tabindex="0"
              @keydown.space.stop.prevent="
                LoginParam.loginInfoSaveFlag = !LoginParam.loginInfoSaveFlag
              "
            ></span>
            <span class="checkbox-text">事業者IDを保持する</span>
          </label>
        </p>
        <p class="login-btn">
          <button
            class="frm-btn strong large"
            style="width: 180px"
            type="button"
            @click.stop="login"
            :disabled="this.isLoginDesabled"
            v-on:keydown.enter="onKeyEnter"
          >
            ログイン
          </button>
        </p>
        <p class="login-notice">{{ RGMessage }}</p>
      </div>
    </div>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
         _/                                                                                                                    _/
         _/      子画面定義：利用規約画面(STDSCM04C04)  ログイン時、利用規約未同意で表示                                       _/
         _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <TearmsOfService
      :requiredTermsOfUseUrl="requiredTermsOfUseUrl"
      :fileData="fileData"
      @confirm="confirm"
      @close="handleTearmsOfServiceClose"
    ></TearmsOfService>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
     _/                                                                                                                    _/
     _/      子画面定義：パスワード変更画面(STDSCM01C03)　　事業者用                                                                         _/
     _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <STDSCM01C03PasswordChangeModal
      :isProcessShow="isProcessShow"
      :oldPassWord="passwordtemp"
      :tatsuzinId="tatsuzinIdtemp"
      :capsLockOn="capsLockOn"
      TdsCssFlg="2"
      @send="send"
      @cancel="cancel"
    ></STDSCM01C03PasswordChangeModal>
    <STDSCM01C02LoginConfrimModal
      :isConfirmShow="isConfirmShow"
      :message="message"
      @agree="agree"
    ></STDSCM01C02LoginConfrimModal>
  </div>
</template>

<script>
import _ from "lodash";
import { mapMutations } from "vuex";
import TearmsOfService from "@/components/STDSCM04C04TearmsOfServiceModal.vue";
import STDSCM01C03PasswordChangeModal from "@/components/STDSCM01C03PasswordChangeModal.vue";
import STDSCM01C02LoginConfrimModal from "@/components/STDSCM01C02LoginConfrimModal.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import Validation from "@/util/validation.js";
import Common from "@/util/common.js";
import {
  API_BopSignout
} from "@/api/Modules/CM04/STDSCM04C00.js";
import {
  API_SigninForPasswordChange,
  API_Login,
  API_BopPortal,
} from "@/api/Modules/CM01/STDSCM01C02.js";
import PasswordInput from "@/components/PasswordInput.vue";

export default {
  name: "STDSCM01C02Login",
  components: {
    STDSCM01C03PasswordChangeModal,
    STDSCM01C02LoginConfrimModal,
    TearmsOfService,
    ErrorMessage,
    ErrorMessageCase,
    PasswordInput,
  },
  data() {
    return {
      isProcessShow: false,
      isConfirmShow: false,
      message: "",
      oldPassWord: "12345",
      //painfo:"",
      LoginParam: {
        tatsuzinId: "",
        password: "",
        loginInfoSaveFlag: false,
        agreedTermsOfUseId: null,
        loginSystem: "",
      },
      tatsuzinIdtemp: "",
      passwordtemp: "",
      errors: [], // エラー情報
      errors_accid: [], // エラー情報_ログインID
      errors_accpass: [], // エラー情報_パスワード
      isErrorAccId: false, // 事業者ID_エラー表示
      isErrorAccPass: false, // パスワード_エラー表示
      isLoginDesabled: false, //ログインボタン_活性状態
      RGMessage: Common.getMessage("MTCL2002", []), //事業者用メッセージ
      msg: Common.getMessage("MTCL2070", []), //capslockメッセージ
      requiredTermsOfUseUrl: "",
      requiredTermsOfUseVersion: null,
      requiredTermsOfUseId: null,
      retstatus: true,
      keyenterflg: false,
      capsLockOn: false,
      showBody: false,
      fileData:""
    };
  },
  watch: {
    //ID入力有無チェック
    tatsuzinIdtemp(newVal) {
      this.LoginParam.tatsuzinId = newVal;
    },
    // パスワード入力有無チェック
    passwordtemp(newVal) {
      this.LoginParam.password = newVal;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.painfo) {
      next((vm) => {
        vm.showBody = false;
        vm.processDialogue(true);
        vm.$cookies.set("painfo", to.query.painfo, "0");
        vm.bopPortal(to.query.painfo,{})
      });
    } else {
      next((vm) => {
        vm.showBody = true;
      });
    }
  },
  //画面表示前処理
  beforeCreate() {
    // リロードを行うか
    if (history.state.reload != null) {
      history.state.reload = null;
      location.reload();
    }
  },
  created() {
    this.$store.commit("businessModule/processDialogue", false);
    // クッキーの取り出し
    const tatsuzinId = this.$cookies.get("tatsuzinIdBop");
    this.tatsuzinIdtemp = _.isNil(tatsuzinId)
      ? this.tatsuzinIdtemp
      : tatsuzinId;
    if (!_.isNil(tatsuzinId)) {
      this.LoginParam.loginInfoSaveFlag = true;
    }
  },
  methods: {
    ...mapMutations("businessModule", [
      "termsServiceDialogue",
      "processDialogue",
    ]),
    ...mapMutations("businessOperatorModule", ["updateBusinessOperatorFlag"]),
    //体験版残日数ダイアログ　OK
    agree() {
      this.isConfirmShow = false;
      //ページ移動
      //this.$redirect({ name: "STDSDR01C01" });
      this.$router.push({
        name: "STFMFM02C29",
      });
    },
    //パスワード変更ボタン押下時
    cancel() {
      this.isProcessShow = false;
    },
    //パスワード変更ボタン押下時
    send(psw) {
      //ユーザー認証クラス.パスワード変更サインイン(事業者用)、ログインを行う。
      const param = {
        tatsuzinId: this.LoginParam.tatsuzinId,
        password: this.LoginParam.password,
        newPassword: psw,
      };

      // パスワード変更ボタン 非活性化
      this.passwordChangeDisabled = true;

      API_SigninForPasswordChange(param).then((response) => {
        if (response.result == "0000") {
          this.$cookies.set("isBopLogin", "true", "0");
          this.$cookies.set("isloginHendle", true, "0");
          this.$cookies.set("SessionID", response.sessionID, "0");
          this.$cookies.set("bopPreOcclusionFlag", true, "0");
          this.updateBusinessOperatorFlag(true);
          if (response.bopUserSigninInfo.availableDays !== 0) {
            this.message = Common.getMessage("MTCL2071", [
              response.bopUserSigninInfo.availableDays,
            ]);
            this.isConfirmShow = true;
          } else {
            //ページ移動
            //this.$redirect({ name: "STDSDR01C01" });
            this.$router.push({
              name: "STFMFM02C29",
            });
          }
        } else if (response.result == "0800") {
          //体験版利用期限切れ 指定ページに遷移する。
          window.location.href = response.url;
        } else if (
          response.result == "1000" ||
          response.result == "1500" ||
          response.result == "1600" ||
          response.result == "1800"
        ) {
          // エラー時フォーカス制御
          this.passwordtemp = "";
          this.$refs.password.focus();
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        } else if (response.result == "0100") {
          // エラー時フォーカス制御
          this.passwordtemp = "";
          this.$refs.password.focus();
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [response.errorName[0]])
            )
          );
        } else {
          this.$router.push({
            name: "STDSCM04C06",
            state: {
              message: Common.getMessage(response.errorCD, []),
            },
          });
        }

        // パスワード変更ボタン 活性化
        this.passwordChangeDisabled = false;
      });

      this.isProcessShow = false;
    },

    // ログイン処理：利用規約同意
    confirm() {
      //利用規約未同意画面非表示
      this.termsServiceDialogue(false);
      this.LoginParam.agreedTermsOfUseVersion = this.requiredTermsOfUseVersion;
      this.LoginParam.agreedTermsOfUseId = this.requiredTermsOfUseId;
      if(this.$cookies.get("painfo")){
        this.bopPortal(this.$cookies.get("painfo"), this.LoginParam)
      } else {
        this.login();
      }
    },

    // ログイン処理
    login() {
      // 入力チェック
      if (!this.handlePushLoginButton()) {
        this.LoginParam.loginInfoSaveFlag = false;
        return;
      }

      const { tatsuzinId, loginInfoSaveFlag } = this.LoginParam;
      // 入力情報保持がチェックONの場合
      if (loginInfoSaveFlag) {
        // クッキーの設定を有効にする
        this.$cookies.set("tatsuzinIdBop", tatsuzinId, -1);
      } else {
        // クッキーの削除
        this.$cookies.remove("tatsuzinIdBop");
      }

      this.isLoginDesabled = true;
      // ログイン
      API_Login(this.LoginParam).then((response) => {
        if (response.result == "0000") {
          this.$cookies.set("isBopLogin", "true", "0");
          this.$cookies.set("SessionID", response.sessionID, "0");
          this.$cookies.set("bopPreOcclusionFlag", true, "0");
          this.$cookies.set("isloginHendle", true, "0");
          this.updateBusinessOperatorFlag(true);
          if (response.availableDays !== 0) {
            this.message = Common.getMessage("MTCL2071", [
              response.availableDays,
            ]);
            this.isConfirmShow = true;
          } else {
            this.$router.push({
              name: "STFMFM02C29",
            });
          }
        } else if (response.result == "0900" || response.result == "0901") {
          this.requiredTermsOfUseVersion = response.requiredTermsOfUseVersion;
          this.requiredTermsOfUseId = response.requiredTermsOfUseId;
          this.requiredTermsOfUseUrl = response.requiredTermsOfUseUrl;
          this.fileData = response.fileData
          //利用規約未同意画面表示
          this.termsServiceDialogue(true);
        } else if (response.result == "1700") {
          //事業者の場合で初回ログインの場合
          this.isProcessShow = true;
        } else if (response.result == "0800") {
          //体験版利用期限切れ 指定ページに遷移する。
          window.location.href = response.url;
        } else {
          // エラー時フォーカス制御
          this.passwordtemp = "";
          switch (response.result) {
            case "0701":
              this.$refs.id.focus();
              break;
            default:
              this.$refs.password.focus();
              break;
          }
          // 入力クリア
          this.LoginParam.password = "";
          this.LoginParam.loginInfoSaveFlag = false;
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }

        this.isLoginDesabled = false;
        this.keyenterflg = false;
      });
    },

    // 事業者ID入力値チェック
    focusoutAccID(input) {
      this.isErrorAccId = false;
      // 必須チェック
      if (!input) {
        this.isErrorAccId = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_accid || this.errors_accid.length == 0) {
          this.errors_accid.push(
            Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", ["事業者ID"])
            )
          );
        }
        return false;
        // 半角チェック
      } else if (!Validation.isHalf(input)) {
        this.isErrorAccId = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_accid || this.errors_accid.length == 0) {
          this.errors_accid.push(
            Common.createError(
              "MTCL1003",
              Common.getMessage("MTCL1003", ["事業者ID"])
            )
          );
        }
        return false;
      }
      return true;
    },

    // パスワード入力値チェック
    focusoutPass(input) {
      this.isErrorAccPass = false;
      // 必須チェック
      if (!input) {
        this.isErrorAccPass = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_accpass || this.errors_accpass.length == 0) {
          this.errors_accpass.push(
            Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", ["パスワード"])
            )
          );
        }
        return false;
        // 半角+記号チェック
      } else if (!Validation.checkCharType(input, "alphanumeric-symbol")) {
        this.isErrorAccPass = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_accpass || this.errors_accpass.length == 0) {
          this.errors_accpass.push(
            Common.createError(
              "MTCL1003",
              Common.getMessage("MTCL1003", ["パスワード"])
            )
          );
        }
        return false;
      }
      return true;
    },

    // ログインボタン押下時
    handlePushLoginButton() {
      this.errors = [];
      this.errors_accid = [];
      this.errors_accpass = [];
      //入力チェック
      if (!this.focusoutAccID(this.LoginParam.tatsuzinId))
        this.retstatus = false;
      if (!this.focusoutPass(this.LoginParam.password)) this.retstatus = false;
      if (!this.retstatus) {
        this.keyenterflg = false;
        this.retstatus = true;
        return false;
      }
      return true;
    },

    // Enterキーでログイン処理を呼び出す
    keyenterflg_operation() {
      this.keyenterflg = true;
    },
    onKeyEnter: function () {
      //Enterキー連打防止
      if (this.keyenterflg) return;
      this.keyenterflg_operation();
      this.login();
    },
    handleTearmsOfServiceClose(){
      let params = this.$cookies.get("painfo")
      if(params){
        API_BopSignout({painfo:params}).then((response)=>{
            if (_.eq(response.result, "0000")) {

                let url = Common.getSettingsValue("BopPortalLoginUrl");
                window.location.href = `${url}`;

            } else {
              this.$router.push({
                name: "STDSCM04C06",
                state: {
                  message: "ログアウト失敗",
                },
              });
            }
        })
        // let url = Common.getSettingsValue("BopPortalServiceMenuUrl");
        // window.location.href = `${url}`;
      }
    },
    bopPortal(painfo,obj){
      API_BopPortal({ painfo, ...obj})
          .then((response) => {
            // 成功の場合
            if (_.eq(response.result, "0000")) {
              this.$cookies.set("isBopLogin", "true", "0");
              this.$cookies.set("SessionID", response.sessionID, "0");
              this.$cookies.set("bopPreOcclusionFlag", true, "0");
              this.$cookies.set("isloginHendle", true, "0");
              this.updateBusinessOperatorFlag(true);
              if (response.availableDays !== 0) {
                this.message = Common.getMessage("MTCL2071", [
                  response.availableDays,
                ]);
                this.isConfirmShow = true;
              } else {
                this.$router.push({
                  name: "STFMFM02C29",
                });
              }
            }  else if (response.result == "0900" || response.result == "0901") {
              this.requiredTermsOfUseVersion = response.requiredTermsOfUseVersion;
              this.requiredTermsOfUseId = response.requiredTermsOfUseId;
              this.requiredTermsOfUseUrl = response.requiredTermsOfUseUrl;
              this.fileData = response.fileData

              //利用規約未同意画面表示
              this.termsServiceDialogue(true);
            } else if (response.result == "1700") {
              //事業者の場合で初回ログインの場合
              this.isProcessShow = true;
            } else if (response.result == "0800") {
              this.handleTearmsOfServiceClose();
              //体験版利用期限切れ 指定ページに遷移する。
              window.location.href = response.url;
            } else {
              this.handleTearmsOfServiceClose();
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.processDialogue(false);
          });
    }
  },

  mounted() {
    this.$nextTick(function () {
      if (this.$refs.id) {
        this.$refs.id.focus();
      }
    });
  },
};
</script>

<style scoped>
.loginbox {
  height: auto;
}

.loginbox >>> .frm-text {
  width: 240px !important;
}
@media (max-width: 768px) {
  /* login */
  .wrapper.login>.body{
    padding: 0 15px;
  }
  .loginbox{
    width: unset !important;
    padding: 30px 20px !important;
  }
  .login-label{
    margin-left:calc((100% - 240px)/2);
  }

  .errMsg.ml-80px {
    margin-left:calc((100% - 240px)/2);
  }
}
</style>
